import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _AssetItemHistory, _FixedAssetItemDepreciation, _Updatedepreciation } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { FixedAssetDepreciationTypeConstants } from "../FixedAssetDepreciationTypeConstants/FixedAssetDepreciationTypeConstants";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";

interface Props {
    idItem: number;
}

export const FixedAssetItemDepreciation = ({ idItem }: Props) => {

    const AssetDepreciationType = useDataBean(_FixedAssetItemDepreciation);
    const updatedeprecation = useDataBean(_Updatedepreciation)
    const single = Singleton.getInstance();
    // const [dperecation, setdperecation] = useState<any>(null)
    // const [resumed, setresumed] = useState<any>(null)
    const [compMainTheme, setMainThemeCompType] = useState<number>(null)
    const [form, setform] = useState<any>({
        dperecation: 5,
        resumed: true
    })
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalvidautil, setModalvidautil] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaltiempodepreciado, setModaltiempodepreciado] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalvalordepreciacion, setModalvalordepreciacion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        console.log('Valores actuales del form en useEffect:', form);
        getLista();
    }, [idItem, form.resumed, form.dperecation]);

    const getLista = () => {

        AssetDepreciationType.instance.getFixedAssetItemDepreciationCatalog(idItem, form.resumed, form.dperecation).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const updateFixedAssetItemDepreciation = () => {

        updatedeprecation.instance.updateFixedAssetItemDepreciation(AssetDepreciationType.bean.IDDepreciation, updatedeprecation.bean.newValue, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    getLista();
                    toast.info('Se realizo la Acción con exito')
                    setModalvalordepreciacion({ ...modalvalordepreciacion, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })
        
    }
    const updateDepreciationTimeForFixedAssetItemDepreciation = () => {
        
        updatedeprecation.instance.updateDepreciationTimeForFixedAssetItemDepreciation(AssetDepreciationType.bean.IDDepreciation, updatedeprecation.bean.newValue, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    getLista();
                    toast.info('Se realizo la Acción con exito')
                    setModaltiempodepreciado({ ...modaltiempodepreciado, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })
        
    }
    const updateLiveTimeForFixedAssetItemDepreciation = () => {
        
        updatedeprecation.instance.updateLiveTimeForFixedAssetItemDepreciation(AssetDepreciationType.bean.IDDepreciation, updatedeprecation.bean.newValue, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    getLista();
                    toast.info('Se realizo la Acción con exito')
                    setModalvalordepreciacion({ ...modalvidautil, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const listaBotones = () => {
        const botones = [
            { titulo: 'Modificar Valor de Depreciación', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalvalordepreciacion({ ...modalvalordepreciacion, "view": true }) } },
            { titulo: 'Modificar Tiempo Depreciado', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModaltiempodepreciado({ ...modaltiempodepreciado, "view": true }) } },
            { titulo: 'Modificar Tiempo Vida Útil', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModalvidautil({ ...modalvidautil, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const head = [
        { title: 'ID', property: 'IDDepreciation', visible: true },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Numero Documento', property: 'Consecutive', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Valor', property: 'DepreciationValue', visible: true },
        { title: 'Tiempo Depreciado', property: 'DepreciationTime', visible: true },
        { title: 'Vida Útil', property: 'LiveTime', visible: true },
        { title: 'Unidades', property: 'DepreciationUnitsTypeName', visible: true },
        { title: 'Valor Item', property: 'ItemValue', visible: true },
        { title: 'IDProceso', property: 'IDProcess', visible: true },
        { title: 'Reclasificación', property: 'Reclassification', visible: true },

    ]




    return (
        <BasicPage titulo="Consultar Depreciaciones">
            <div className="row">
                <div className="col-md-4">
                    <FixedAssetDepreciationTypeConstants
                        idSelector={form.dperecation}
                        onChange={(e: any) => {
                            setform((prev: any) => ({ ...prev, dperecation: e }));
                        }}
                    />
                </div>
                <div className="col-md-4">
                    <BasicSwitch
                        label="Informe Resumido"
                        estado={form.resumed}
                        eventChange={(e: any) => {
                            setform((prev: any) => ({ ...prev, resumed: e }));
                        }}
                    />
                </div>
                {/* <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar por Filtros*</BasicButton>
                </div> */}

                <div className="col-md-12">
                    <Modal modal={modalvalordepreciacion} updateModal={setModalvalordepreciacion} eventModal={updateFixedAssetItemDepreciation}>
                        <div className="row">
                            <div className="col-md-6">
                                <strong>Modificar Valor de Depreciación ?*</strong>
                            </div>

                            <div className="col-md-12">
                                <InputMoney _label="Valor Depreciado" _value={updatedeprecation.bean.newValue} onChange={(e) => { updatedeprecation.setBean({ ...updatedeprecation.bean, "newValue": e }) }} />
                            </div>

                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaltiempodepreciado} updateModal={setModaltiempodepreciado} eventModal={updateDepreciationTimeForFixedAssetItemDepreciation}>
                        <div className="row">
                            <div className="col-md-6"><strong>Modificar Tiempo Depreciado ?*</strong></div>
                            <div className="col-md-12">
                                <label>Tiempo Depreciado</label>
                                <input type="text" name="Name" className="form-control" value={updatedeprecation.bean.newValue} onChange={(e) => { updatedeprecation.setBean({ ...updatedeprecation.bean, "newValue": e.target.value }) }} />
                            </div>


                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalvidautil} updateModal={setModalvidautil} eventModal={updateLiveTimeForFixedAssetItemDepreciation}>


                        <div className="row">
                            <div className="col-md-6"><strong>Modificar Tiempo Vida Útil ?*</strong></div>
                            <div className="col-md-12">
                                <label>Tiempo Vida Útil</label>
                                <input type="text" name="Name" className="form-control" value={updatedeprecation.bean.newValue} onChange={(e) => { updatedeprecation.setBean({ ...updatedeprecation.bean, "newValue": e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>
                </div>


                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={AssetDepreciationType.setBean} listButtons={!form.resumed ? listaBotones() : undefined} ></BasicTable>

                </div>

            </div>
        </BasicPage>
    )
}